import { Box, Button, CircularProgress, Grid2, Typography } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { viewPDF } from "../../../../utils/viewPDF";
import { uploadFile } from "../../../../utils/uploadToAzure";

const Step2 = ({ rfq, setRfq, setStep, storedUser, fileNames, setFileNames }) => {
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const { rfqId } = useParams();
  const navigate = useNavigate();
  const orgId = JSON.parse(localStorage.getItem("org"));
  const [uploadLoading, setUploadLoading] = useState(false);

  const handleChange = (e) => {
    setRfq({ ...rfq, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = rfq || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.term1)) {
      newErrors.term1 = "Delivery period (Lead Time) is required";
    } else if (data.term1.length > 1000) {
      newErrors.term1 =
        "Delivery period (Lead Time) should be upto 1000 characters";
    }
    if (isEmpty(data.term2)) {
      newErrors.term2 = "Payment Terms is required";
    } else if (data.term2.length > 1000) {
      newErrors.term2 = "Payment Terms should be upto 1000 characters";
    }
    if (isEmpty(data.term3)) {
      newErrors.term3 = "Freight is required";
    } else if (data.term3.length > 1000) {
      newErrors.term3 = "Freight should be upto 1000 characters";
    }
    if (isEmpty(data.term4)) {
      newErrors.term4 = "Price Basis (Incoterms) is required";
    } else if (data.term4.length > 1000) {
      newErrors.term4 =
        "Price Basis (Incoterms) should be upto 1000 characters";
    }
    // if (isEmpty(data.term5)) {
    //   newErrors.term5 = "Term 5 is required";
    // } else if (data.term5.length > 1000) {
    //   newErrors.term5 = "Term 5 should be upto 1000 characters";
    // }
    // if (isEmpty(data.term6)) {
    //   newErrors.term6 = "Term 6 is required";
    // } else if (data.term6.length > 1000) {
    //   newErrors.term6 = "Term 6 should be upto 1000 characters";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFileUpload = async (e) => {
    const { name, files } = e.target;
    setUploadLoading(true);
    if (files && files.length > 0) {
      const file = files[0]; // Get the first file

      // Update the file names state
      setFileNames((prev) => ({
        ...prev,
        document: file.name, // Set the filename in state
      }));

      const formData = new FormData();
      formData.append("file", file);

      try {
        // const res = await axios.post(
        //   `${process.env.REACT_APP_BACKEND_URL}/file/upload`,
        //   formData,
        //   {
        //     headers: {
        //       "Content-Type": "multipart/form-data",
        //       Authorization: `Bearer ${storedUser.accessToken}`,
        //     },
        //   }
        // );
        const res = await uploadFile(file, orgId, rfq.draftRfqId, storedUser)
        // Set the received file path in tender state
        setRfq({ ...rfq, document: res });
        setErrors({ ...errors, document: "" });
      } catch (error) {
          console.error("File upload error: Please upload file upto 1MB");
        console.error("File upload error:", error);
      } finally {
        setUploadLoading(false);
      }
    }
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft?draftRfqId=${rfq.draftRfqId}`,
        {
          document: rfq.document,
          documentFilename: fileNames.document,
          term1: rfq.term1,
          term2: rfq.term2,
          term3: rfq.term3,
          term4: rfq.term4,
          term5: rfq.term5,
          term6: rfq.term6,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate(`/dashboard/create-rfq/draft/${rfq.draftRfqId}`);
    setStep((prev) => prev - 1);
    // if(rfqId !== undefined){
    //   getDraft()
    // }
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Create New RFQ</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "16%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">Terms</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="document">
              Attachments
              <div className={`input-file ${errors.document && "input-error"}`}>
                <input
                  type="file"
                  id="document"
                  name="document"
                  onChange={handleFileUpload}
                />
                <span
                  style={{
                    width: "80%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {fileNames.document || "No file chosen"}
                </span>
                <AttachFileIcon
                  fontSize="small"
                  sx={{
                    color: "#555",
                    transform: "rotate(90deg)",
                    "&:hover": { color: "#1A71F6BF" },
                  }}
                />
              </div>
            </label>
            <Box>
              {errors.document && <p className="error">{errors.document}</p>}
              {uploadLoading && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
              {rfq && rfq.document && (
                <Button
                  sx={{
                    margin: "-6% 0 0 0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(rfq.document, storedUser)}
                >
                  {fileNames.document}
                </Button>
              )}
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="term1">
              Delivery period (Lead Time)
              <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <textarea
              className={`${errors.term1 && "input-error"}`}
              name="term1"
              id="term1"
              onChange={handleChange}
              value={rfq && rfq?.term1}
              rows={2}
            />
            {errors.term1 && <p className="error">{errors.term1}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="term2">
              Payment Terms<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <textarea
              className={`${errors.term2 && "input-error"}`}
              name="term2"
              id="term2"
              onChange={handleChange}
              value={rfq && rfq?.term2}
              rows={2}
            />
            {errors.term2 && <p className="error">{errors.term2}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="term3">
              Freight<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <textarea
              className={`${errors.term3 && "input-error"}`}
              name="term3"
              id="term3"
              onChange={handleChange}
              value={rfq && rfq?.term3}
              rows={2}
            />
            {errors.term3 && <p className="error">{errors.term3}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="term4">
              Price Basis (Incoterms)<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <textarea
              className={`${errors.term4 && "input-error"}`}
              name="term4"
              id="term4"
              onChange={handleChange}
              value={rfq && rfq?.term4}
              rows={2}
            />
            {errors.term4 && <p className="error">{errors.term4}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="term5">Warranty Period</label>
            <textarea
              className={`${errors.term5 && "input-error"}`}
              name="term5"
              id="term5"
              onChange={handleChange}
              value={rfq && rfq?.term5}
              rows={2}
            />
            {errors.term5 && <p className="error">{errors.term5}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="term6">Late Delivery Clause</label>
            <textarea
              className={`${errors.term6 && "input-error"}`}
              name="term6"
              id="term6"
              onChange={handleChange}
              value={rfq && rfq?.term6}
              rows={2}
            />
            {errors.term6 && <p className="error">{errors.term6}</p>}
          </Grid2>
        </Grid2>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step2;
